import CloseIcon from '../../icons/close';

import './styles/notice-region.css';

export default function NoticeRegion({ notices, onDismiss }) {
    return (
        <div className="notice-region" role="status" aria-live="polite" aria-atomic="false">
            {notices.map((notice) => (
                <div key={notice.id} className={`notice-region__item notice-region__item--${notice.tone}`}>
                    <p className="notice-region__message">{notice.message}</p>
                    <button
                        type="button"
                        className="notice-region__close"
                        onClick={() => onDismiss(notice.id)}
                    >
                        <CloseIcon size={18} />
                        <span className="visually-hidden">Cerrar aviso</span>
                    </button>
                </div>
            ))}
        </div>
    );
}
